import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableUtil } from '../../../../tableUtil';
import { TranslatorService } from '../../../../services/translator_service';
import { FilteredSiteEntry, InvoiceItem } from '../invoice-item/invoice-item';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-invoice-list',
  imports: [CommonModule, TranslatePipe, InvoiceItem],
  templateUrl: './invoice-list.html',
  styleUrl: './invoice-list.scss',
})
export class InvoiceList {
  @Input() entries: FilteredSiteEntry[] = [];
  @Input() period = '';
  @Input() grandTotal = '';

  constructor(private translator: TranslatorService) {}

  exportToExcel(): void {
    const isHebrew = this.translator.isRTL();
    const sheetsByEventType = new Map<string, object[]>();

    for (const entry of this.entries) {
      for (const event of entry.events) {
        const row = {
          [isHebrew ? 'אתר'            : 'Site']:          entry.site.siteName,
          [isHebrew ? 'מזהה פח'        : 'Bin']:           event.bin,
          [isHebrew ? 'סוג פח'         : 'Bin Type']:      event.binType,
          [isHebrew ? 'תאריך'          : 'Date']:          event.date,
          [isHebrew ? 'יחידות'         : 'Units']:         event.units,
          [isHebrew ? 'כתובת'          : 'Address']:       event.address,
          [isHebrew ? 'חוזה'           : 'Contract']:      event.contract,
          [isHebrew ? 'סכום'           : 'Amount']:        event.amount,
        };

        const eventTypeName = event.eventType || (isHebrew ? 'ללא סוג אירוע' : 'Other');
        let eventTypeRows = sheetsByEventType.get(eventTypeName);
        if (!eventTypeRows) {
          eventTypeRows = [];
          sheetsByEventType.set(eventTypeName, eventTypeRows);
        }
        eventTypeRows.push(row);
      }
    }

    const sheets = Array.from(sheetsByEventType.entries()).map(([name, rows]) => ({ name, rows }));
    TableUtil.exportSheetsToExcel(sheets, isHebrew ? 'חשבוניות' : 'Invoices', this.exportPeriod());
  }

  private exportPeriod(): string {
    const period = (this.period || '').trim();
    if (!period) { return ''; }
    const parts = period.split('\u2013').map(part => part.trim());
    if (parts.length == 2 && parts[0] == parts[1]) { return parts[0]; }
    return period;
  }
}
